import React, { Fragment } from "react";
import clsx from "clsx";
import { Token } from "~/types";
import TokenItem, { TokenColumn } from "./TokenItem";
import SkeletonTokenListItem from "./SkeletonTokenListItem";

type TokenListProps = {
    tokens: Token[];
    isLoading: boolean;
    columns: TokenColumn[];
    onTokenClick: (token: Token) => void;
    isFavoriteAble?: boolean;
    onFavoriteClick?: (token: Token) => void;
    deferredKeyword?: string;
    showHead?: boolean;
    preComponent?: (token: Token) => React.ReactNode;
    layout?: "Page" | "Modal";
};

const TokenList: React.FC<TokenListProps> = ({
    isLoading,
    tokens,
    columns,
    onTokenClick,
    deferredKeyword: deferredKeyword = "",
    layout = "Modal",
    isFavoriteAble,
    onFavoriteClick,
    preComponent,
}) => {
    return (
        <div
            className={clsx(
                layout === "Modal" && "flex-auto relative overflow-hidden"
            )}
        >
            <div
                className={clsx(
                    layout === "Modal" &&
                        "absolute top-0 left-0 right-0 bottom-0 overflow-auto"
                )}
            >
                {isLoading ? (
                    <SkeletonTokenListItem
                        count={10}
                        isFavoriteAble={isFavoriteAble}
                    />
                ) : (
                    <Fragment>
                        {tokens.map((token, index) => (
                            <TokenItem
                                deferredKeyword={deferredKeyword}
                                key={index}
                                token={token}
                                tokenIndex={index}
                                columns={columns}
                                onTokenClick={onTokenClick}
                                isFavoriteAble={isFavoriteAble}
                                onFavoriteClick={onFavoriteClick}
                                preComponent={preComponent}
                            />
                        ))}
                    </Fragment>
                )}
            </div>
        </div>
    );
};

export default React.memo(TokenList);
